/* KODA Event: gallery lightbox + click-to-load video */
(function () {
  if (window.__kodaEventMedia) return;
  window.__kodaEventMedia = true;

  /* ---------- Video facade: swap the cover for the player on click ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ke-video]');
    if (!btn) return;
    e.preventDefault();
    var src = btn.getAttribute('data-ke-video');
    if (!src) return;
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = btn.getAttribute('aria-label') || 'Video';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    iframe.allowFullscreen = true;
    iframe.className = 'ke-vid__media';
    btn.replaceWith(iframe);
  });

  /* ---------- Gallery lightbox ---------- */
  var state = { links: [], i: 0, dlg: null };

  function show(i) {
    var n = state.links.length;
    if (!n || !state.dlg) return;
    state.i = (i + n) % n;
    var a = state.links[state.i];
    var img = state.dlg.querySelector('.ke-lb__img');
    var thumb = a.querySelector('img');
    img.src = a.getAttribute('href');
    img.alt = thumb ? thumb.alt : '';
    var multi = n > 1;
    state.dlg.querySelector('.ke-lb__prev').hidden = !multi;
    state.dlg.querySelector('.ke-lb__next').hidden = !multi;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-ke-lb]');
    if (!a) return;
    var wrap = a.closest('[data-ke-gallery]');
    var block = wrap && wrap.parentElement;
    var dlg = block && block.querySelector('dialog.ke-lb');
    if (!dlg || typeof dlg.showModal !== 'function') return; /* falls back to opening the image */
    e.preventDefault();
    state.links = Array.prototype.slice.call(wrap.querySelectorAll('a[data-ke-lb]'));
    state.dlg = dlg;
    show(state.links.indexOf(a));
    dlg.showModal();
    document.documentElement.style.overflow = 'hidden';
  });

  document.addEventListener('click', function (e) {
    var dlg = e.target.closest('dialog.ke-lb');
    if (!dlg) return;
    if (e.target.closest('.ke-lb__prev')) { show(state.i - 1); return; }
    if (e.target.closest('.ke-lb__next')) { show(state.i + 1); return; }
    if (e.target.closest('.ke-lb__close') || e.target === dlg) dlg.close();
  });

  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.ke-lb')) {
      document.documentElement.style.overflow = '';
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!state.dlg || !state.dlg.open) return;
    if (e.key === 'ArrowLeft') show(state.i - 1);
    if (e.key === 'ArrowRight') show(state.i + 1);
  });

  /* simple swipe on touch */
  var x0 = null;
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest('dialog.ke-lb')) x0 = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    x0 = null;
    if (Math.abs(dx) > 40) show(state.i + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();
